import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path fill="#0AA1F4" d="M6.667 10.115l6.127-6.129.944.943L6.667 12 2.423 7.757l.942-.942 3.3 3.3z"></path>
    </svg>
  )
}

export default Icon
